module.exports = __webpack_public_path__ + "img/logo_horizontal.8ee58d0c.gif";